export default "__VITE_ASSET__Bw$9245p__"